// Didim hakkında 30 soru içeren quiz veritabanı
export const didimQuizData = [
  {
    id: 1,
    question: "Didim hangi ilin ilçesidir?",
    options: ["İzmir", "Aydın", "Muğla", "Antalya"],
    correctAnswer: 1,
    difficulty: "easy",
  },
  {
    id: 2,
    question: "Didim'in eski adı nedir?",
    options: ["Ephesus", "Didyma", "Miletus", "Priene"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 3,
    question: "Didim'deki ünlü antik tapınak hangi tanrıya adanmıştır?",
    options: ["Zeus", "Artemis", "Apollon", "Athena"],
    correctAnswer: 2,
    difficulty: "medium",
  },
  {
    id: 4,
    question: "Didim'in en ünlü plajı hangisidir?",
    options: ["Altınkum", "Sarıkum", "Akbük", "Mavisoy"],
    correctAnswer: 0,
    difficulty: "easy",
  },
  {
    id: 5,
    question: "Apollon Tapınağı'nın inşasına hangi dönemde başlanmıştır?",
    options: ["MÖ 8. yüzyıl", "MÖ 6. yüzyıl", "MÖ 4. yüzyıl", "MÖ 2. yüzyıl"],
    correctAnswer: 0,
    difficulty: "hard",
  },
  {
    id: 6,
    question: "Didim'de hangi deniz bulunur?",
    options: ["Karadeniz", "Akdeniz", "Ege Denizi", "Marmara Denizi"],
    correctAnswer: 2,
    difficulty: "easy",
  },
  {
    id: 7,
    question: "Didim'in nüfusu yaklaşık kaçtır?",
    options: ["50.000", "75.000", "100.000", "125.000"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 8,
    question: "Didim'de bulunan antik şehir hangisidir?",
    options: ["Ephesus", "Miletos", "Pergamon", "Troy"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 9,
    question: "Didim'in en yoğun turist sezonu hangi aylardır?",
    options: ["Nisan-Mayıs", "Haziran-Ağustos", "Eylül-Ekim", "Kasım-Aralık"],
    correctAnswer: 1,
    difficulty: "easy",
  },
  {
    id: 10,
    question: "Didim'deki Apollon Tapınağı'nın sütun sayısı kaçtır?",
    options: ["104", "120", "88", "96"],
    correctAnswer: 1,
    difficulty: "hard",
  },
  {
    id: 11,
    question: "Didim hangi antik yolun üzerinde yer alıyordu?",
    options: ["İpek Yolu", "Kutsal Yol", "Roma Yolu", "Kral Yolu"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 12,
    question: "Didim'in Bodrum'a uzaklığı yaklaşık kaç km'dir?",
    options: ["45 km", "60 km", "75 km", "90 km"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 13,
    question: "Didim'de hangi tarihî olay yaşanmıştır?",
    options: [
      "Büyük İskender'in ziyareti",
      "Sezar'ın savaşı",
      "Hannibal'ın geçişi",
      "Pompey'in kaçışı",
    ],
    correctAnswer: 0,
    difficulty: "hard",
  },
  {
    id: 14,
    question: "Altınkum Plajı'nın kum rengi neden altın sarısıdır?",
    options: [
      "Mineral içeriği",
      "Güneş ışığı",
      "Deniz akıntıları",
      "Volkanik aktivite",
    ],
    correctAnswer: 0,
    difficulty: "medium",
  },
  {
    id: 15,
    question: "Didim'in en eski yerleşim yeri neresidir?",
    options: ["Altınkum", "Akbük", "Hisar", "Mavişehir"],
    correctAnswer: 2,
    difficulty: "hard",
  },
  {
    id: 16,
    question: "Didim'de hangi spor dalı popülerdir?",
    options: ["Kayak", "Su sporları", "Dağcılık", "Bisiklet"],
    correctAnswer: 1,
    difficulty: "easy",
  },
  {
    id: 17,
    question: "Apollon Tapınağı'nın mimari stili nedir?",
    options: ["Dor", "İon", "Korint", "Karma"],
    correctAnswer: 1,
    difficulty: "hard",
  },
  {
    id: 18,
    question: "Didim'in İzmir'e uzaklığı yaklaşık kaç km'dir?",
    options: ["120 km", "150 km", "180 km", "200 km"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 19,
    question: "Didim'de hangi mevsim en az yağış alır?",
    options: ["İlkbahar", "Yaz", "Sonbahar", "Kış"],
    correctAnswer: 1,
    difficulty: "easy",
  },
  {
    id: 20,
    question: "Didim'deki antik tiyatro kaç kişi kapasitelidir?",
    options: ["5.000", "8.000", "12.000", "15.000"],
    correctAnswer: 2,
    difficulty: "hard",
  },
  {
    id: 21,
    question: "Didim'in en ünlü yerel yemeği hangisidir?",
    options: ["Köfte", "Balık ekmek", "Meze", "Kebap"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 22,
    question: "Didim Marina'da kaç tekne yanaşabilir?",
    options: ["200", "300", "400", "500"],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 23,
    question: "Didim'de hangi festival düzenlenir?",
    options: [
      "Müzik Festivali",
      "Kültür ve Sanat Festivali",
      "Yemek Festivali",
      "Hepsi",
    ],
    correctAnswer: 3,
    difficulty: "medium",
  },
  {
    id: 24,
    question: "Apollon Tapınağı'nın yüksekliği kaç metredir?",
    options: ["15 m", "20 m", "25 m", "30 m"],
    correctAnswer: 1,
    difficulty: "hard",
  },
  {
    id: 25,
    question: "Didim'in en büyük oteli hangisidir?",
    options: [
      "Didim Beach Resort",
      "Aqua Fantasy",
      "Club Hotel Turan",
      "Venosa Beach Resort",
    ],
    correctAnswer: 1,
    difficulty: "medium",
  },
  {
    id: 26,
    question: "Didim'de hangi antik yapı kalıntısı bulunur?",
    options: ["Amfitiyatro", "Stadyum", "Agora", "Hepsi"],
    correctAnswer: 3,
    difficulty: "medium",
  },
  {
    id: 27,
    question: "Didim'in rakımı kaç metredir?",
    options: ["0-50 m", "50-100 m", "100-150 m", "150-200 m"],
    correctAnswer: 0,
    difficulty: "medium",
  },
  {
    id: 28,
    question: "Didim'de hangi ağaç türü yaygındır?",
    options: ["Çam", "Zeytin", "Meşe", "Kavak"],
    correctAnswer: 1,
    difficulty: "easy",
  },
  {
    id: 29,
    question: "Didim'in en eski camisi hangisidir?",
    options: ["Ulu Cami", "Hisar Camii", "Merkez Camii", "Yeni Cami"],
    correctAnswer: 1,
    difficulty: "hard",
  },
  {
    id: 30,
    question: "Didim'de hangi antik medeniyetin izleri bulunur?",
    options: ["Hitit", "Yunan", "Roma", "Yunan ve Roma"],
    correctAnswer: 3,
    difficulty: "medium",
  },
];

// Quiz ayarları
export const quizConfig = {
  questionsPerQuiz: 5,
  totalQuestions: 30,
  timePerQuestion: 30, // saniye
  passingScore: 60, // yüzde
};
